import React from "react";
import { formatDate } from "./common";
export default function TextImage({ totalItem, isPromotion, data, isSmall }) {
    const getPhotoByDevice = () => {
        if (isSmall)
            return data.images.tablet;
        const deviceWidth = window.innerWidth;
        if (deviceWidth < 768)
            return data.images.mobile;
        else if (deviceWidth >= 768 && deviceWidth <= 1024)
            return data.images.tablet;
        else
            return data.images.desktop;
    };
    return (React.createElement("div", { className: "rt-text-image", style: totalItem >= 2 ? { display: "block" } : {} },
        React.createElement("div", { className: "rt-promo-container" },
            isPromotion && React.createElement("span", { className: "rt-promo-label" }, "Promozione"),
            data.startDate && (React.createElement("div", { className: "rt-promo-label-data" },
                formatDate(data.startDate, data.startTime),
                " ",
                " - ",
                formatDate(data.endDate, data.endTime)))),
        React.createElement("div", { className: "rt-text-image-content", style: {
                backgroundImage: `linear-gradient(to bottom, rgba(245, 246, 252, 0), rgb(12 10 12 / 48%)), url(${getPhotoByDevice()})`,
                backgroundPosition: "center",
                backgroundSize: "cover",
            } }),
        React.createElement("div", { className: "rt-text-content" },
            React.createElement("h3", { className: "rt-title", dangerouslySetInnerHTML: { __html: data.title } }),
            React.createElement("p", { className: "rt-subtitle", dangerouslySetInnerHTML: { __html: data.text } }),
            data.textButton !== "" && (React.createElement("a", { className: "rt-text-button", href: data.link }, data.textButton)))));
}
